import {
  useInitializeUseCase,
  useNavigationService,
  usePlatformService,
  useResources,
  useTrackingService,
} from '@/di/di.root-container.hooks';

import {useEffect, useMemo} from 'react';
import {useLocation, useNavigate} from 'react-router';
import {BrowserRouter as Router} from 'react-router-dom';

import {routes} from '@/routes/routes';
import {FontLoaderGuard} from '@/ui/common/FontLoaderGuard/FontLoaderGuard';
import {ProjectFinishedModal} from '@/ui/common/ProjectFinishedModal/ProjectFinishedModal';
import {ScrollToTop} from '@/ui/common/ScrollToTop/ScrollToTop';

export default function App(): JSX.Element {
  const initializeUseCase = useInitializeUseCase();
  const {
    config: {projectFinished},
  } = useResources();

  // инициализация должна произойти до рендера AppRoutes, в противном случае AppRoutes отрендерятся с isMb === false,
  // а затем isMb === true внутри мобильного экрана, т.к. useEffect вызывается уже после рендера
  // @see: https://jira.tcsbank.ru/browse/SP-18178
  useMemo(() => {
    void initializeUseCase.init();
  }, []);

  return (
    <Router>
      {projectFinished.isModalActive && <ProjectFinishedModal />}

      <ScrollToTop />

      <AppRoutes />
    </Router>
  );
}

function AppRoutes(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const navigationService = useNavigationService();
  const trackingService = useTrackingService();
  const platformService = usePlatformService();

  // добавляем tracking.updateLocation, потому что при переходе между страницами нужно обновлять
  // адрес текущей страницы в объект window.tracking.state.url, автоматически этого не происходит,
  // поэтому требуется явно указывать, что location изменился
  useEffect(() => {
    trackingService.updateLocation();
  }, [location]);

  // вся навигация в приложении будет происходить через navigationService, для этого необходимо передать
  // имплементацию функции navigate из пакета react-router-dom
  useEffect(() => {
    navigationService.setNavigate(navigate);
  }, [navigate]);

  return <FontLoaderGuard>{platformService.isMb() ? routes.mb : routes.web}</FontLoaderGuard>;
}
